// app/src/api/core/limiter.ts

import pLimit from "p-limit"

/**
 * 브라우저 표준 연결 제한에 맞춘 글로벌 동시 요청 제한 (도메인당 6개)
 * serverApi와 queApi가 공유하는 단일 제한자
 *
 * 이 제한자는 HTTP 에러를 방지하기 위해 모든 API 요청에 적용됩니다.
 */
export const globalApiLimit = pLimit(5)

/**
 * 중요한 API (visit, encounter 등)를 위한 우선순위 제한자
 * 더 적은 동시 실행으로 빠른 응답 보장
 */
export const criticalApiLimit = pLimit(1)

/**
 * 글로벌 API 제한자를 사용하여 요청을 제한하는 래퍼 함수
 * serverApi와 queApi가 공유하여 사용
 *
 * @param requestFn 실행할 API 요청 함수
 * @returns 제한된 API 요청의 Promise 결과
 */
export const limitedRequest = <T>(requestFn: () => Promise<T>): Promise<T> => {
  return globalApiLimit(requestFn)
}

/**
 * 중요한 API를 위한 우선순위 제한 래퍼 함수
 * visit, encounter 등 핵심 기능에 사용
 *
 * @param requestFn 실행할 API 요청 함수
 * @returns 제한된 API 요청의 Promise 결과
 */
export const criticalLimitedRequest = <T>(requestFn: () => Promise<T>): Promise<T> => {
  return criticalApiLimit(requestFn)
}

/**
 * 현재 대기 중인 요청 수 반환
 * 디버깅 목적으로 사용
 */
export const getPendingRequestCount = (): number => {
  return globalApiLimit.pendingCount
}

/**
 * 현재 활성 요청 수 반환
 * 디버깅 목적으로 사용
 */
export const getActiveRequestCount = (): number => {
  return globalApiLimit.activeCount
}
